import tableSales from '@/views/private/realestate/salesinquiry/components/tableSales/tableSales.vue'
import formSales from '@/views/private/realestate/salesinquiry/components/formSales/formSales.vue'
import DetailsSales from './components/detailssales/detailssales.vue'
import PermissionMixin from '@/store/module/permission/mixin'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import Roles from '@/shared/utils/roles.js'
export default {
  name: 'SalesInquiry',
  mixins: [ PermissionMixin ],
  components: {
    tableSales,
    formSales,
    DetailsSales
  },
  data () {
    return {
      flDetails: false,
      tablereload: 0,
      selectedComissao: {},
      roles: Roles
    }
  },
  methods: {
    updateCorretor (newCommissionArray, newResponse) {
    },
    edit (obj) {
      this.selectedComissao = obj
      this.flDetails = true
    },
    deleteCommission (id) {
      CommissionRepository.DeleteComissao(id)
        .then(Response => {
          this.consultacomissao = Response.data.data
          this.tablereload++
          this.$refs.tableGridComission.Delete(Response)
        })
        .catch(() => {})
    },
    GetFilter (search, notClean = true) {
      let filterOn = false
      if (notClean === true) {
        Object.keys(search).forEach((Element) => {
          if (search[Element] !== '' && Element !== 'corretorId' && Element !== 'corretor') {
            filterOn = true
          }
          if (Element === 'corretor') {
            if (search[Element].value !== null) {
              filterOn = true
            }
          }
          if (Element === 'corretorId') {
            if (search[Element] !== null) {
              filterOn = true
            }
          }
        })
        if (filterOn === true) {
          this.$refs.tableCommissionCheck.searching(search)
        } else {
          this.$refs.tableCommissionCheck.disableFilter()
        }
      } else {
        this.$refs.tableCommissionCheck.disableFilter()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesinquiry/salesinquiry.js